(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1271],{

/***/ 38086:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clases/curso-scrum-developer-guayaquil",
      function () {
        return __webpack_require__(84125);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RedirectLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30341);
/* harmony import */ var _components_Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19976);




var defaultProps = {};
var propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node.isRequired)
};
function RedirectLayout(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-gray-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex w-full items-center justify-center py-10 lg:py-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col items-center space-y-4 text-gray-600",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: "w-10 h-10",
                            show: true,
                            inverse: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                            className: "mx-auto max-w-screen-md text-center font-medium",
                            children: [
                                "Esta direcci\xf3n ha cambiado",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-sm text-gray-500",
                                    children: "Le estamos redireccionando a la nueva direcci\xf3n."
                                })
                            ]
                        }),
                        children
                    ]
                })
            })
        })
    });
};
RedirectLayout.defaultProps = defaultProps;
RedirectLayout.propTypes = propTypes;


/***/ }),

/***/ 68497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var nextjs_redirect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50241);

/* harmony default export */ __webpack_exports__["Z"] = (nextjs_redirect__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 60123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ redirectOther; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _RedirectLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9849);
/* harmony import */ var _redirect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68497);



function redirectOther(url) {
    var Redirect = (0,_redirect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(url, {
        statusCode: 303
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RedirectLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Redirect, {})
    });
};


/***/ }),

/***/ 19976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Spinner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Spinner/Spinner.js



var defaultProps = {
    show: false,
    inverse: false,
    size: "h-4 w-4"
};
var propTypes = {
    show: (prop_types_default()).bool,
    inverse: (prop_types_default()).bool,
    size: (prop_types_default()).string
};
function Spinner(param) {
    var show = param.show, inverse = param.inverse, size = param.size;
    if (show === false) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: (0,clsx_m/* default */.Z)("animate-spin", size, inverse === false && "text-white", inverse === true && "text-gray-900"),
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: "4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                })
            ]
        })
    });
};
Spinner.defaultProps = defaultProps;
Spinner.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Spinner/index.js

/* harmony default export */ var components_Spinner = (Spinner);


/***/ }),

/***/ 84125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_Redirect_redirectOther__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60123);

var Redirect = function() {
    return (0,_components_Redirect_redirectOther__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/clases");
};
/* harmony default export */ __webpack_exports__["default"] = (Redirect);


/***/ }),

/***/ 50241:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
const _jsxFileName = "src/index.tsx";__webpack_unused_export__ = ({value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = __webpack_require__(67294); var _react2 = _interopRequireDefault(_react);
var _router = __webpack_require__(11163); var _router2 = _interopRequireDefault(_router);
var _head = __webpack_require__(9008); var _head2 = _interopRequireDefault(_head);

exports.Z = (
  redirectUrl,
  options
) =>
  class extends _react2.default.Component {
    // Redirects on the server side first if possible
    static async getInitialProps({ res }) {
      if (_optionalChain([res, 'optionalAccess', _ => _.writeHead])) {
        res.writeHead(_nullishCoalesce(_optionalChain([options, 'optionalAccess', _2 => _2.statusCode]), () => ( 301)), { Location: redirectUrl })
        res.end()
      }
      return {}
    }

    // Redirects on the client with JavaScript if no server
    componentDidMount() {
      if (_optionalChain([options, 'optionalAccess', _3 => _3.asUrl]) != null) {
        _router2.default.push(redirectUrl, options.asUrl, { shallow: true })
      } else if (redirectUrl[0] === '/') {
        _router2.default.push(redirectUrl)
      } else {
        window.location.href = redirectUrl
      }
    }

    render() {
      const href = _nullishCoalesce(_optionalChain([options, 'optionalAccess', _4 => _4.asUrl]), () => ( redirectUrl))

      return (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement(_head2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
            /* Redirects with meta refresh if no JavaScript support */
            , _react2.default.createElement('noscript', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
              , _react2.default.createElement('meta', { httpEquiv: "refresh", content: `0;url=${href}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}} )
            )
            , (_optionalChain([options, 'optionalAccess', _5 => _5.statusCode]) === undefined ||
              _optionalChain([options, 'optionalAccess', _6 => _6.statusCode]) === 301) && (
              _react2.default.createElement('link', { rel: "canonical", href: href, __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}} )
            )
          )
          /* Provides a redirect link if no meta refresh support; or children if provided */
          , this.props.children ? (
            this.props.children
          ) : (
            _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}, "Redirecting to "
                , _react2.default.createElement('a', { href: href, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, href), "…"
            )
          )
        )
      )
    }
  }


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(38086); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);